var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ds-arrow-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M9 11.55L4.5 7.05L5.55 6L9 9.45L12.45 6L13.5 7.05L9 11.55Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }